import { isNotNil } from "@etudescarre/utils";
import { useCallback, useEffect, useState } from "react";
import { apiClient } from "@/lib/api/client";
import { useYardContext } from "@/providers/yard-context";
import {
  notifyProposalsChanged,
  useOnProposalsChanged,
} from "./proposals-changed";
import { proposalContent, SendProposalButton } from "./send-proposal-button";

export type ProposalSendBarProps = {
  onSent?: () => void;
};

/** « Envoyer la proposition » for each rang 2 contract of the user. */
export function ProposalSendBar({ onSent }: ProposalSendBarProps) {
  const { yard, contracts } = useYardContext();
  const rang2Contracts = contracts.filter((c) => c.type === "travaux_n_2");
  const [draftCounts, setDraftCounts] = useState<
    Map<number, { draftCount: number; draftMaquetteCount: number }>
  >(new Map());

  const fetchCounts = useCallback(async () => {
    const { data } = await apiClient.GET("/api/yards/{yardId}/proposals", {
      params: { path: { yardId: String(yard.id) } },
    });
    if (isNotNil(data)) {
      setDraftCounts(
        new Map(data.data.contracts.map((c) => [c.contractId, c])),
      );
    }
  }, [yard.id]);

  useEffect(() => {
    fetchCounts();
  }, [fetchCounts]);
  useOnProposalsChanged(fetchCounts);

  return (
    <div className="mt-2 space-y-2">
      {rang2Contracts.map((contract) => {
        const { draftCount = 0, draftMaquetteCount = 0 } =
          draftCounts.get(contract.id) ?? {};
        return (
          <div key={contract.id} className="flex items-center gap-3 px-3">
            <SendProposalButton
              yardId={String(yard.id)}
              contractId={contract.id}
              draftCount={draftCount}
              draftMaquetteCount={draftMaquetteCount}
              onSent={() => {
                notifyProposalsChanged();
                onSent?.();
              }}
            />
            <span className="text-xs text-zinc-500">
              {rang2Contracts.length > 1
                ? `${contract.performerCompanyName} : `
                : ""}
              {proposalContent(draftCount, draftMaquetteCount)} en brouillon
            </span>
          </div>
        );
      })}
    </div>
  );
}
